const components = new Map()

components.set('name', ctx => ({
  key: 'name',
  defaultPlacement: 'template',
  component: 'Input',
  props: {
    label: ctx.labels.name,
    'data-field': 'name',
  },
}))

components.set('ofType', ctx => {
  return {
    key: 'ofType',
    defaultPlacement: 'template',
    component: 'Select',
    disabled: !ctx.isNew,
    props: {
      'data-field': 'ofType',
      label: ctx.labels.ofType,
      items: [
        { value: 'Project', label: ctx.labels.project },
        { value: 'Page', label: ctx.labels.page },
      ],
    },
  }
})

components.set('isDefault', ctx => ({
  key: 'isDefault',
  defaultPlacement: 'template',
  component: 'Radio',
  props: {
    'data-field': 'isDefault',
    label: ctx.labels.addAsDefault,
    items: [
      { value: true, label: ctx.labels.yes },
      { value: false, label: ctx.labels.no },
    ],
  },
}))

components.set('categories', ctx => ({
  key: 'categories',
  defaultPlacement: 'template',
  component: 'Tags',
  props: {
    'data-field': 'categories',
    label: ctx.labels.categories,
    placeholder: ctx.labels.categoriesPlaceholder,
  },
}))

components.set('projectTheme', ctx => {
  const isPage = ctx.data.ofType === 'Page'
  return {
    key: isPage ? 'data.theme.template' : 'data.theme',
    defaultPlacement: 'template',
    component: 'ThemeSelector',
    disabled: !ctx.isNew,
    condition: ['Page', 'Project'].includes(ctx.data.ofType),
    props: {
      data: ctx.data,
      'data-field': 'theme',
    },
  }
})

export default components
